import { useFilterRewardContext } from "./filter-reward.context";

export function FilterReward() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterRewardContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}